/* eslint-disable */
import React, { useContext, useEffect, useState, useRef } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import { message } from 'antd';
import _get from 'lodash/get';
import { useQuery, useMutation, useSubscription, useApolloClient } from '@apollo/client';
import { StyleSheet, css } from 'aphrodite/no-important';
//import { Device } from 'twilio-client';
import { Device } from '@twilio/voice-sdk';
import { LoadingOutlined } from '@ant-design/icons';
import Push from 'push.js';
import { queryPatientAndPharmacy } from 'graphql/patients.js';
import { SessionContext } from 'contexts/SessionContextProvider';
import { CallCenterContext } from 'contexts/CallCenterContextProvider';
import { OutcomesContext } from 'contexts/OutcomesProvider';
import DialPad from './DialPad';
import CallCenterStatus from './CallCenterStatus';
import CallOutcomeModal from './CallOutcomeModal';
import CallPatientButton from './CallPatientButton';
import InboundCall from './InboundCall';
import MakeActive from './MakeActive';
import OnCallElsewhere from './OnCallElsewhere';
import OnCallContainer from './OnCallContainer';
import OnCallSupervising from './OnCallSupervising';
import SaveNumberModal from './SaveUnknownNumberModal';
import PATIENT_SUBSCRIPTION from "../../patients/info/graphql/patientSubscription";
import { GET_UPDATED_PHARMACY_SUBSCRIPTION } from "../../graphql/pharmacies"
import { COLORS } from './constants';
import {
  getFormattedPhoneAssociations,
  buildPatientInfo,
  getTwilioTokenQuery,
  getPhoneRecordsQuery,
  getCallRecordQuery,
} from './util';
import {
  CREATE_CALL_RECORD,
  GET_PHONES_WITH_ASSOCIATIONS,
  UPDATE_USER_ACTIVITY,
  UPDATE_CALL_RECORD,
  GET_USER_CALL_CENTER_STATUS,
} from './queries';
import SEARCH_MEMBERS from 'graphql/searchMembers';
import { useLocation, useNavigate } from 'react-router-dom';

const sx = StyleSheet.create({
  callCenterContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '6rem',
    borderBottom: '1px solid #D9D9D9',
  },
  dialCont: {
    display: 'flex',
    height: '60px',
  },
  callCenterBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '40px',
    margin: '10px',
    lineHeight: '14px',
  },
  inboundCall: {
    backgroundColor: COLORS.LIGHT_GREEN,
    margin: '0px',
    padding: '10px',
    height: '60px',
    width: '100vw',
  },
  green: {
    background: COLORS.LIGHT_GREEN,
  },
});
const deviceRef = { current: null };

function registerTwilioDevice(
  token,
  setTwilioConnection,
  setCallDetails,
  setInboundCall,
  deregisterTwilioRefContext,
  resetCallCenterState,
  updateCallCenterStatusMutationContext,
  currentCallIdRef,
  apolloClient,
  setIsCallCenterActivatedContext,
  twilioTokenExpiredRef,
  setOnCallDialingParticipant,
  setIsOnCall,
  setShowConnectingTwilio,
  setIsOutboundPatient,
  setUpdatedPharmacyContext,
  userId,
  deviceRef
) {
  if (!token) {
    return;
  }
  const device = new Device(token, {
    closeProtection: 'A call is currently in progress. Leaving or reloading this page will end the call.',
    enableRingingState: true,
    enableIceRestart: true,
    logLevel: 1,
  });
  deviceRef.current = device;

  // This is allowing incoming calls to work
  const handleSuccessfulRegistration = () => {
    console.log('The device is ready to receive incoming calls.')
  }
  device.on('registered', handleSuccessfulRegistration);
  device.register();
  // device.setup(token, {
  //   closeProtection:
  //     '"A call is currently in progress. Leaving or reloading this page will end the call."',
  //   enableRingingState: true,
  //   enableIceRestart: true,
  // });
  device.on('ready', () => {
    deregisterTwilioRefContext.current = false; // eslint-disable-line no-param-reassign
  });

  device.on('reconnected', () => {
    // eslint-disable-next-line
    alert('Twilio connection has been restored');
  });

  device.on('error', e => {
    // Token expired https://www.twilio.com/docs/api/errors/31205
    if (e.code === 31205) {
      if (!currentCallIdRef.current) {
        updateCallCenterStatusMutationContext('unavailable');
        setIsCallCenterActivatedContext(false);
        twilioTokenExpiredRef.current = false;
      } else {
        twilioTokenExpiredRef.current = true;
      }

      return;
    }

    // Mic access denied https://www.twilio.com/docs/api/errors/31208
    if (e.code === 31208) {
      // eslint-disable-next-line
      alert('Enable microphone access first inorder for call center to work');
    }

    if (e.code === 31003 || e.code === 31005) {
      // eslint-disable-next-line
      alert('Internet connection is unstable. Check your internet.');

      return;
    }

    message.error(`Twilio error occurred: ${e.code}: ${e.message}`);

    // eslint-disable-next-line
    FS.log('error', `Twilio error occurred: ${e.code}: ${e.message}`);

    resetCallCenterState();
  });

  // Offline event is also triggered when the token expires
  device.on('offline', () => {
    if (!currentCallIdRef.current) {
      setIsCallCenterActivatedContext(false);
    }
  });
  device.on('connect', async conn => {
    //const handleConnection = async (conn) => {
    setShowConnectingTwilio(false);
    setTwilioConnection(conn);
    const callId = conn.customParameters.get('callId');
    const callerName = _get(conn, 'message.name');
    if (conn.direction === 'OUTGOING') {
      const callSid = _get(conn, 'parameters.CallSid');

      // if call initiate on dialpad, just check for unknown name
      // else get phoneRecords
      let isDialingPatient = false;
      if (callerName !== 'Unknown') {
        const phoneId = _get(conn, 'message.toPhoneId');
        if (phoneId) {
          const phoneRecordsOnConnect = await apolloClient.query({
            query: GET_PHONES_WITH_ASSOCIATIONS,
            variables: { query: { id: phoneId } },
            fetchPolicy: 'network-only',
          });
          const phoneRecordsData = _get(phoneRecordsOnConnect, 'data.phones.data');
          if (phoneRecordsData?.length > 0) {
            isDialingPatient = !!phoneRecordsData.find(p => p.patient_id);
            setUpdatedPharmacyContext(phoneRecordsData[0].patient?.assigned_pharmacy_id);
          }
        }
      }

      const onCallDialingData = {
        names: [callerName === 'Unknown' ? 'Unknown Caller' : _get(conn, 'message.name')],
        callSids: [callSid],
      };

      if (isDialingPatient) {
        onCallDialingData.participantType = 'patient';
        setIsOutboundPatient(true);
      }
      // We don't show the numbers if the outgoing call is a pharmacy
      if (!_get(conn, 'message.toPharmacyId')) {
        onCallDialingData.numbers = [_get(conn, 'message.to')];
      }

      setOnCallDialingParticipant(onCallDialingData);
    }

    updateCallCenterStatusMutationContext('oncall', parseInt(callId, 10));
    setIsOnCall(true);
  });
  device.on('cancel', () => {
    resetCallCenterState();
  });

  device.on('incoming', async conn => {
    const userInfoOnIncoming = await apolloClient.query({
      query: GET_USER_CALL_CENTER_STATUS,
      variables: { userId },
      fetchPolicy: 'network-only',
    });
    deviceRef.current = device;
    const userInfo = _get(userInfoOnIncoming, 'data.getCallCenterStatusByUserId.data');

    // We reject the call if there's already an incoming call happening
    if (currentCallIdRef.current || userInfo?.call_center_user_status !== 'available') {
      conn.reject();
      return;
    }

    const inboundCaller = _get(conn, 'customParameters').get('inCaller');
    const inboundCallerType = _get(conn, 'customParameters').get('inType');

    const continueSettingInboundCall = async () => {
      currentCallIdRef.current = parseInt(_get(conn, 'customParameters').get('callId'), 10);
      if (inboundCallerType === 'number') {
        // Make an api call to get the inbound caller information.
        const phoneRecords = await getPhoneRecordsQuery(apolloClient, inboundCaller);
        const formattedPhoneAssoc = getFormattedPhoneAssociations(phoneRecords);

        if (phoneRecords && phoneRecords.length > 0) {
          setUpdatedPharmacyContext(phoneRecords[0].patient?.assigned_pharmacy_id);
        }

        const { bestCandidate } = formattedPhoneAssoc;
        let name = bestCandidate?.phone_label.includes('CPCC')
          ? bestCandidate?.phone_label
          : bestCandidate.name;

        const inboundInfo = {
          name: name,
          patient_id: _get(formattedPhoneAssoc, 'bestCandidate.patient_id'),
          label: _get(formattedPhoneAssoc, 'bestCandidate.label'),
          phone: _get(formattedPhoneAssoc, 'number'),
          insurance: _get(formattedPhoneAssoc, 'bestCandidate.payer.name'),
        };
        setCallDetails(inboundInfo);

        setInboundCall(inboundInfo);
      }
      // Inbound is from an enroller
      else {
        const inboundCallerDetails = JSON.parse(inboundCaller) || {};
        const toSetVal = {
          name: inboundCallerDetails.name || inboundCallerDetails.email || 'Unknown Caller',
          label: inboundCallerType,
        }
        setInboundCall(toSetVal);
        setCallDetails(toSetVal);
      }
    };

    // As long as there isn't a current call, continue setting the inbound call and call id
    continueSettingInboundCall();

    Push.create('You have a new inbound call.', {
      onClick() {
        window.focus();
        this.close();
      },
    });

    // Handling connection events for inbound calls
    conn.on('accept', () => {
      setIsOnCall(true);
      const callId = conn.customParameters.get('callId');
      updateCallCenterStatusMutationContext('oncall', parseInt(callId, 10));
    });

    setTwilioConnection(conn);
  });
}
const handleConnection = async (conn, setShowConnectingTwilio,
  setTwilioConnection, setOnCallDialingParticipant, updateCallCenterStatusMutationContext,
  setIsOnCall, apolloClient, setUpdatedPharmacyContext, setIsOutboundPatient, setCallCenterPatientId,
  patientId = null, activeCallPatientIdRef = null
) => {
  setShowConnectingTwilio(false);
  setTwilioConnection(conn);
  console.log('conn', conn);
  if (!conn) {
    return;
  }
  const callId = conn.customParameters.get('callId');
  const callerName = conn.customParameters.get('name');

  //const callerName = _get(conn, 'message.name');
  if (conn.direction === 'OUTGOING') {
    const callSid = await getCallSid(conn)

    // if call initiate on dialpad, just check for unknown name
    // else get phoneRecords
    let isDialingPatient = false;
    if (callerName !== 'Unknown') {
      //const phoneId = _get(conn, 'message.toPhoneId');
      const phoneId = conn.customParameters.get('toPhoneId');
      if (phoneId) {
        const phoneRecordsOnConnect = await apolloClient.query({
          query: GET_PHONES_WITH_ASSOCIATIONS,
          variables: { query: { id: phoneId } },
          fetchPolicy: 'network-only',
        });
        const phoneRecordsData = _get(phoneRecordsOnConnect, 'data.phones.data');
        if (phoneRecordsData?.length > 0) {
          const matchedRecord = patientId
            ? phoneRecordsData.find(p => p.patient_id === patientId) || phoneRecordsData.find(p => p.patient_id)
            : phoneRecordsData.find(p => p.patient_id);
          const calledPatientId = matchedRecord?.patient_id;
          isDialingPatient = !!calledPatientId;
          setUpdatedPharmacyContext(phoneRecordsData[0].patient?.assigned_pharmacy_id);
          // don't let an unmatched fallback lookup clobber a patient already anchored for this call (e.g. from Call Patient Button)
          const anchoredToDifferentPatient =
            activeCallPatientIdRef?.current && activeCallPatientIdRef.current !== calledPatientId;
          if (!!calledPatientId && !anchoredToDifferentPatient) {
            if (activeCallPatientIdRef) {
              activeCallPatientIdRef.current = calledPatientId;
            }
            setCallCenterPatientId(calledPatientId);
          }
        }
      }
    }

    const onCallDialingData = {
      names: [callerName === 'Unknown' ? 'Unknown Caller' : conn.customParameters.get('name')],
      callSids: [callSid],
    };

    if (isDialingPatient) {
      onCallDialingData.participantType = 'patient';
      setIsOutboundPatient(true);
    }
    // We don't show the numbers if the outgoing call is a pharmacy
    if (!conn.customParameters.get('toPharmacyId')) {
      onCallDialingData.numbers = [conn.customParameters.get('to')];
    }

    setOnCallDialingParticipant(onCallDialingData);
  }

  updateCallCenterStatusMutationContext('oncall', parseInt(callId, 10));
  setIsOnCall(true);
};
const getCallSid = async (conn) => {
  while (!conn.parameters.CallSid) {
    console.log('Fetching CallSid from connection');
    await new Promise(resolve => setTimeout(resolve, 100)); // Poll every 100ms
  }
  return conn.parameters.CallSid;
};

async function makeOutboundCall({
  userId,
  toPhoneId,
  number,
  name,
  callId,
  toPharmacyId,
  fromCallerId,
  enrollerCallSid = null,
  currentCallId = null,
  patientId = null,
  activeCallPatientIdRef = null,
  setShowConnectingTwilio,
  setTwilioConnection,
  setOnCallDialingParticipant,
  updateCallCenterStatusMutationContext,
  setIsOnCall,
  apolloClient,
  setUpdatedPharmacyContext,
  setIsOutboundPatient,
  setCallCenterPatientId
}) {
  const options = enrollerCallSid
    ? {
      confFriendlyNameToCoach: currentCallId,
      callSidToCoach: enrollerCallSid,
      callId: currentCallId,
      fromCallerId,
    }
    : {
      userId,
      to: number,
      toPhoneId,
      name,
      callId,
      fromCallerId,
    };
  if (toPharmacyId) {
    options.toPharmacyId = toPharmacyId;
  }
  if (deviceRef.current) {
    const connection = await deviceRef.current.connect({ params: options });
    if (connection) {
      handleConnection(connection, setShowConnectingTwilio, setTwilioConnection,
        setOnCallDialingParticipant, updateCallCenterStatusMutationContext, setIsOnCall, 
        apolloClient, setUpdatedPharmacyContext, setIsOutboundPatient, setCallCenterPatientId,
        patientId, activeCallPatientIdRef
      );
    }
  }
  //device.connect(options);
}

const CallCenterBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentCallIdRef = useRef(null);
  const twilioTokenExpiredRef = useRef(null);
  const apolloClient = useApolloClient();
  const unknownNumberRef = useRef(null);
  const refreshActiveConfRef = useRef(false);
  const unknownNumberCallIdRef = useRef(null);
  const activeCallPatientIdRef = useRef(null);
  const [cancelUnloadEvent, setCancelUnloadEvent] = useState(false);
  const [showOutcomeModal, setOutcomeModalVisible] = useState(false);
  const [isCallIdSet, setCallId] = useState(false);

  const {
    pharmacyStatus,
    pharmacyReassigned,
    outboundToPhoneIdContext,
    setOutboundToPhoneIdContext,
    isCallCenterActivatedContext,
    setIsCallCenterActivatedContext,
    selectedPatientId,
    setSelectedPatientId,
    updateCallCenterStatusMutationContext,
    callCenterUserStatusContext,
    deregisterTwilioRefContext,
    supervisingCallContext,
    setSupervisingCallContext,
  } = useContext(CallCenterContext);
  const { setUpdatedPharmacyContext } = useContext(OutcomesContext);

  const { userId } = useContext(SessionContext);
  const [callDetails, setCallDetails] = useState({});
  const [isUnknownNumberSaved, setIsUnknownNumberSaved] = useState(false);
  const [patientIdForUnknownNumber, setPatientIdForUnknownNumber] = useState(null);

  const [inboundCall, setInboundCall] = useState(null);
  const [twilioConnection, setTwilioConnection] = useState(null);
  const [loadingTwilioToken, setLoadingTwilioToken] = useState(false);
  const [isOnCall, setIsOnCall] = useState(false);
  const [isSaveNumberModalOpen, setIsSaveNumberModalOpen] = useState(false);
  const [onCallDialingParticipant, setOnCallDialingParticipant] = useState(null);
  const [showConnectingTwilio, setShowConnectingTwilio] = useState(false);
  const [saveCallOnly, setSaveCallOnly] = useState(false);
  const [saveCallEnabled, setSaveCallEnabled] = useState(true);
  const [isPostCall, setIsPostCall] = useState(false);
  const [lastCallId, setLastCallId] = useState(null);
  const [isSaveUnknownSuccess, setIsSaveUnknownSuccess] = useState(false);
  const [isInboundPatient, setIsInboundPatient] = useState(false);
  const [isOutboundPatient, setIsOutboundPatient] = useState(false);
  const [callCenterPatientId, setCallCenterPatientId] = useState(null);
  // const [dataVersion, setDataVersion] = useState(0); //TECD-920

  // ================================= API CALL =================================== //
  const {
    loading: selectedPatInfoLoading,
    data: selectedPatInfoData,
    refetch: refetchPharmacy,
    // startPolling: startPollGetActiveConf,
    // stopPolling: stopPollGetActiveConf,
  } = useQuery(queryPatientAndPharmacy, {
    skip: !callCenterPatientId,
    fetchPolicy: 'network-only',
    variables: { id: callCenterPatientId },
  });

  useEffect(() => {
    const isUnknownCaller = twilioConnection?.customParameters?.get('name')?.includes('Unknown Caller') ?? false;
    const isIncomingUnknownCall = twilioConnection?._direction === 'INCOMING' && callDetails.name === 'Unknown Caller';
    if (isUnknownNumberSaved && !!patientIdForUnknownNumber) {
      refetchPharmacy({ id: patientIdForUnknownNumber })
        .then(() => {
          // setDataVersion(prevVersion => prevVersion + 1); // TECD-920
        })
        .catch((error) => console.error("Refetch error:", error));
    } else if (selectedPatientId && (isUnknownCaller || isIncomingUnknownCall)) {
      refetchPharmacy({ id: selectedPatientId })
        .then(() => {
          // setDataVersion(prevVersion => prevVersion + 1); // TECD-920
        })
        .catch((error) => console.error("Refetch error:", error));
    }
  }, [selectedPatientId, refetchPharmacy, callDetails, isUnknownNumberSaved, patientIdForUnknownNumber]);

  // useEffect(() => {
  //   if (isOnCall) {
  //     startPollGetActiveConf(1000);
  //   } else {
  //     stopPollGetActiveConf();
  //   }
  // }, [isOnCall]);


  useEffect(() => {
  if (!callCenterPatientId) return;

  let subscription;
  let retryTimeout;

  const subscribe = () => {
    subscription = apolloClient.subscribe({
      query: PATIENT_SUBSCRIPTION,
      variables: { patientId: `${callCenterPatientId}` },
    }).subscribe({
      next() {
        refetchPharmacy();
      },
      error(error) {
        const errorMessage = error?.message || String(error);
        if (/socket closed.*\b1002\b/i.test(errorMessage) ||
          /socket closed.*\b4500\b/i.test(errorMessage)) {
          // Reconnect after 3s on expected socket closes
          retryTimeout = setTimeout(subscribe, 3000);
          return;
        }
        message.error(`Error in active conference subscription: ${errorMessage}`);
        // Reconnect after 5s on unexpected errors
        retryTimeout = setTimeout(subscribe, 5000);
      },
    });
  };

  subscribe();

  return () => {
    clearTimeout(retryTimeout);
    subscription?.unsubscribe();
  };
}, [callCenterPatientId]);

  const { data: pharmacySubs } = useSubscription(GET_UPDATED_PHARMACY_SUBSCRIPTION, {
    variables: { id: _get(selectedPatInfoData, 'patients.data[0].assigned_pharmacy.id') },
    skip: !_get(selectedPatInfoData, 'patients.data[0].assigned_pharmacy.id'),
    shouldResubscribe: true, // should be set to true when conference id changes
    fetchPolicy: 'network-only',
    onSubscriptionData: (data) => {
      refetchPharmacy();
    },
    onError: error => {
      const errorMessage = error?.message || String(error);
      if (/socket closed.*\b1002\b/i.test(errorMessage) ||
        /socket closed.*\b4500\b/i.test(errorMessage)) return;
      message.error(`Error in active conference subscription: ${errorMessage}`);
    },
  });


  useEffect(() => {
    const isUnknownCaller = twilioConnection?.customParameters?.get('name')?.includes('Unknown Caller') ?? false;
    const isIncomingUnknownCall = twilioConnection?._direction === 'INCOMING' && callDetails.name === 'Unknown Caller';
    const isUnknownCallerActiveAndNotSaved = (isUnknownCaller || isIncomingUnknownCall) && !isUnknownNumberSaved;
    if (activeCallPatientIdRef.current) {
      if (callCenterPatientId !== activeCallPatientIdRef.current) {
        setCallCenterPatientId(activeCallPatientIdRef.current);
      }
      return;
    }
    if ((!isOnCall && !showOutcomeModal) || !callCenterPatientId) {
      setCallCenterPatientId(selectedPatientId);
    } else if (isOnCall && !showOutcomeModal && isUnknownCallerActiveAndNotSaved && callCenterPatientId !== selectedPatientId) {
      setCallCenterPatientId(selectedPatientId);
    }
  }, [selectedPatientId, isOnCall, showOutcomeModal]);

  useEffect(() => {
    if (pharmacyReassigned || pharmacyStatus || callCenterPatientId) {
      refetchPharmacy();
    }
  }, [pharmacyReassigned, pharmacyStatus, callCenterPatientId]);

  const [createCallRecordMutation] = useMutation(CREATE_CALL_RECORD, {
    onError: error => {
      message.error(`Error when creating call record: ${error.message}`);
    },
  });

  const [updateCallRecordMutation] = useMutation(UPDATE_CALL_RECORD, {
    onError: error => {
      message.error(`Error when updating call record: ${error.message}`);
    },
  });

  const [updateUserActivity] = useMutation(UPDATE_USER_ACTIVITY, {
    onError: error => {
      // eslint-disable-next-line
      console.error(`Error when updating user activity: ${error.message}`);
    },
  });

  // ================================ useEffect ======================================= //

  useEffect(() => {
    updateUserActivity();
    const intervalID = setInterval(updateUserActivity, 30000);

    return function cleanup() {
      clearInterval(intervalID);

    // Disconnect active connection
    if (twilioConnection) {
      twilioConnection.disconnect();
    }

    // Remove all event listeners and destroy device
    if (deviceRef.current) {
      deviceRef.current.removeAllListeners && deviceRef.current.removeAllListeners();
      deviceRef.current.destroy();
      deviceRef.current = null;
    }

      setIsCallCenterActivatedContext(false);
      setOutboundToPhoneIdContext(null);
      setLastCallId(currentCallIdRef.current);
      currentCallIdRef.current = null;
      twilioTokenExpiredRef.current = null;
      unknownNumberRef.current = null;
      refreshActiveConfRef.current = false;
      unknownNumberCallIdRef.current = null;
    };
  }, []);

  useEffect(() => {
    function beforUnloadHandler(e) {
      e.preventDefault();
      updateCallCenterStatusMutationContext('unavailable');

      // Browser does not render the custom message anymore as a security feature but you still need to return a value to show the dialog box
      // https://developers.google.com/web/updates/2016/04/chrome-51-deprecations?hl=en#remove_custom_messages_in_onbeforeunload_dialogs
      // eslint-disable-next-line no-param-reassign
      e.returnValue = '';

      setCancelUnloadEvent(true);
    }

    if (isCallCenterActivatedContext) {
      window.addEventListener('beforeunload', beforUnloadHandler);
    } 
    // Always clean up on unmount
    return () => {
      if(isCallCenterActivatedContext){
        window.removeEventListener('beforeunload', beforUnloadHandler);
      }
    };
  }, [isCallCenterActivatedContext]);

  // This useEffect is used to determine whether user tried to leave the app or close the tab.
  useEffect(() => {
    if (cancelUnloadEvent) {
      setIsCallCenterActivatedContext(false);
      setCancelUnloadEvent(false);
    }
  }, [cancelUnloadEvent]);

  // This useEffect is triggered by components outside the call center bar. i.e. pressing call button in the members profile
  useEffect(() => {
    async function initiateOutboundCall() {
      const phoneRecords = await apolloClient.query({
        query: GET_PHONES_WITH_ASSOCIATIONS,
        variables: { query: { id: outboundToPhoneIdContext } },
        fetchPolicy: 'network-only',
      });

      const formattedPhones = getFormattedPhoneAssociations(_get(phoneRecords, 'data.phones.data'), selectedPatientId);
      const { bestCandidate } = formattedPhones;
      const { number } = formattedPhones;

      if (bestCandidate?.patient_id) {
        activeCallPatientIdRef.current = bestCandidate.patient_id;
        setCallCenterPatientId(bestCandidate.patient_id);
      }

      const r = bestCandidate?.pharmacy_id
        ? await createCallRecordMutation({
          variables: {
            toPhoneId: bestCandidate?.phone_id,
            toPharmacyId: bestCandidate?.pharmacy_id,
            direction: 'outbound',
          },
        })
        : await createCallRecordMutation({
          variables: {
            toPhoneId: outboundToPhoneIdContext,
            direction: 'outbound',
          },
        });

      const callId = _get(r, 'data.createCallRecord.data.callId');
      const fromCallerId = _get(r, 'data.createCallRecord.data.callerIdNumber');
      currentCallIdRef.current = parseInt(callId, 10);

      if (bestCandidate?.pharmacy_id) {
        makeOutboundCall({
          userId,
          toPharmacyId: bestCandidate?.pharmacy_id,
          toPhoneId: outboundToPhoneIdContext,
          number,
          name: _get(bestCandidate, 'name'),
          callId,
          fromCallerId,
          activeCallPatientIdRef,
          setShowConnectingTwilio,
          setTwilioConnection,
          setOnCallDialingParticipant,
          updateCallCenterStatusMutationContext,
          setIsOnCall,
          apolloClient,
          setUpdatedPharmacyContext,
          setIsOutboundPatient,
          setCallCenterPatientId
        });
      } else {
        makeOutboundCall({
          userId,
          toPhoneId: outboundToPhoneIdContext,
          number,
          name: _get(bestCandidate, 'name'),
          callId,
          fromCallerId,
          patientId: bestCandidate?.patient_id,
          activeCallPatientIdRef,
          setShowConnectingTwilio,
          setTwilioConnection,
          setOnCallDialingParticipant,
          updateCallCenterStatusMutationContext,
          setIsOnCall,
          apolloClient,
          setUpdatedPharmacyContext,
          setIsOutboundPatient,
          setCallCenterPatientId
        });
      }
      setOutboundToPhoneIdContext(null);
      if (r) {
        setCallId(true);
      }
    }

    // Initiate outbound only when your not on a call.
    if (outboundToPhoneIdContext && !isOnCall) {
      initiateOutboundCall();
    }
  }, [outboundToPhoneIdContext]);

  useEffect(() => {
    if (!_isEmpty(supervisingCallContext) && isCallCenterActivatedContext) {
      const enrollerCallSid = supervisingCallContext.enrollerCallSid;
      const currentCallId = supervisingCallContext.currentCallId;
      makeOutboundCall({
        enrollerCallSid,
        currentCallId,
        setShowConnectingTwilio,
        setTwilioConnection,
        setCallCenterPatientId
      });
    }
  }, [supervisingCallContext]);

  async function resetCallCenterState() {
    setInboundCall(null);
    setOnCallDialingParticipant(null);
    setIsOnCall(false);

    if (twilioConnection) {
      twilioConnection.disconnect();
    }
    setTwilioConnection(null);

    setLastCallId(currentCallIdRef.current);
    currentCallIdRef.current = null;
    activeCallPatientIdRef.current = null;

    // Reset twilio device if the token expired.
    if (twilioTokenExpiredRef.current) {
      //Device.destroy();
      deviceRef.current.destroy();
      twilioTokenExpiredRef.current = false;
    }
  }

  function onClickUnknownNumber(unknownNumber, saveCallOnly) {
    setSaveCallOnly(saveCallOnly);
    setIsSaveNumberModalOpen(true);
    unknownNumberRef.current = unknownNumber;
    unknownNumberCallIdRef.current = currentCallIdRef.current;
  }

  function resetStatesAfterPostCall() {
    setSaveCallEnabled(true);
    updateCallCenterStatusMutationContext('available');
    // setIsPostCall(false); // CPTC: 831, commenting this line seems to fix modal dismissal issue
    setIsSaveUnknownSuccess(false);
  }

  function resetStatesAfterSavingCallOrNumber() {
    setSaveCallEnabled(true);
    if(!isOnCall){
      updateCallCenterStatusMutationContext('available');
    }
    setIsSaveUnknownSuccess(false);
  }

  async function onSuccessSaveNumber(updatedPhoneId, updatedCallId) {
    const isUnknownCaller = twilioConnection?.customParameters?.get('name')?.includes('Unknown Caller') ?? false;
    const isIncomingUnknownCall = twilioConnection?._direction === 'INCOMING' && callDetails.name === 'Unknown Caller';
    if (isUnknownCaller || isIncomingUnknownCall) {
      setIsUnknownNumberSaved(true);
      setPatientIdForUnknownNumber(selectedPatientId);
    }
    await updateCallRecordMutation({
      variables: {
        call_id: parseInt(updatedCallId, 10),
        from_phone_id: parseInt(updatedPhoneId, 10),
      },
    });
    if (!isPostCall) {
      setIsSaveUnknownSuccess(true);
    }
    refreshActiveConfRef.current = true;
    setIsSaveNumberModalOpen(false);
    if (isPostCall) {
      // open outcome modal if unknown number was saved at the end of the call
      setOutcomeModalVisible(true);
    }
  }

  function setToPostCall() {
    updateCallCenterStatusMutationContext('postcall');
    setIsPostCall(true);
    resetCallCenterState();
  }

  function isNotPatientOrInboundBeforePickUp() {
    return (
      (inboundCall ||
      (onCallDialingParticipant && onCallDialingParticipant?.participantType !== 'patient'))
      && !onMembersPage
    );
  }

  function isPatientBeforePickUp() {
    return (
      (inboundCall && inboundCall?.label === 'Patient') ||
      (onCallDialingParticipant && onCallDialingParticipant?.participantType === 'patient')
    );
  }

  async function checkIfParticipantAfterCall(phoneId, participants) {
    // checks if patient is added in the beginning of the call or any time during the call
    const checkParticipant =
      (participants?.length > 0 && !!participants?.find(p => p.type === 'patient')) ||
      isInboundPatient ||
      isOutboundPatient ||
      isSaveUnknownSuccess;

    // if initial check fails, searches call record to see if patient is on the call record
    if (!checkParticipant) {
      const currentPhoneRecord = await apolloClient.query({
        query: GET_PHONES_WITH_ASSOCIATIONS,
        variables: { query: { id: phoneId } },
        fetchPolicy: 'network-only',
      });
      const phoneRecordsData = _get(currentPhoneRecord, 'data.phones.data');
      if (phoneRecordsData?.length > 0) {
        return !!phoneRecordsData?.find(p => p.patient_id);
      }
    } else {
      return checkParticipant;
    }
  }

  async function isEnrollerOnCallRecord(participants) {
    const callRecord = await getCallRecordQuery(apolloClient, currentCallIdRef.current);
    const fromUserOnCallRecord = _get(callRecord, 'from_user_id');
    const toUserOnCallRecord = _get(callRecord, 'to_user_id');
    const callDirection = _get(callRecord, 'direction');
    const isCallInbound = callDirection === 'inbound';
    const phoneId = isCallInbound
      ? _get(callRecord, 'from_phone_id')
      : _get(callRecord, 'to_phone_id');
    const isUserOnCallRecord = isCallInbound
      ? toUserOnCallRecord === userId
      : fromUserOnCallRecord === userId;
    const isPatientOnTheCall = await checkIfParticipantAfterCall(phoneId, participants);
    return { isUserOnCallRecord, isPatientOnTheCall };
  }

  async function endConference(unknownNumber, currentParticipants) {
    const { isUserOnCallRecord, isPatientOnTheCall } = await isEnrollerOnCallRecord(
      currentParticipants,
    );
    setIsUnknownNumberSaved(false);
    setPatientIdForUnknownNumber(null);
    if (isNotPatientOrInboundBeforePickUp() || !isUserOnCallRecord) {
      // if dialing a non-patient, non-patient did not pick up
      resetCallCenterState();
      resetStatesAfterPostCall();
    } else if (isPatientBeforePickUp()) {
      // if dailing patient, patient did not pick up
      setOutcomeModalVisible(true);
      setToPostCall();
    } else {
      if (unknownNumber && onMembersPage) {
        if (saveCallEnabled && !saveCallOnly) {
          // if unknown number & number was not saved during call
          setIsSaveNumberModalOpen(true);
          unknownNumberCallIdRef.current = currentCallIdRef.current;
          unknownNumberRef.current = unknownNumber;
          setToPostCall();
          return;
        }
        unknownNumberCallIdRef.current = currentCallIdRef.current;
        unknownNumberRef.current = unknownNumber;
      }
      if (isSaveUnknownSuccess) {
        // if unknown number was saved during call
        setSaveCallEnabled(true);
        setOutcomeModalVisible(true);
        setToPostCall();
        return;
      } else if (isPatientOnTheCall) {
        // if patient picked up
        setOutcomeModalVisible(true);
        setIsInboundPatient(false);
        setIsOutboundPatient(false);
        setToPostCall();
        return;
      }
      // if non-patient picked up
      resetCallCenterState();
      resetStatesAfterPostCall();
    }
  }

  function getPatientName(patientParticipant) {
    const patientName = patientParticipant?.name;
    if (
      onCallDialingParticipant?.participantType === 'patient' &&
      onCallDialingParticipant?.names?.length &&
      !onCallDialingParticipant.names.includes(patientName)
    ) {
      return onCallDialingParticipant.names[0];
    }
    return patientName;
  }

  async function onCallUpdatingParticipants(currentParticipants) {
    // if (callCenterPatientId) {
    //   return;
    // }
    // if (!!callCenterPatientId && !!onCallDialingParticipant) {
    //   refetchPharmacy();
    //   return;
    // }
    const patientParticipant = currentParticipants?.find(p => p.type === 'patient');
    if (!!patientParticipant) {
      async function fetchMemberByName(name) {
        const members = await apolloClient.query({
          query: SEARCH_MEMBERS,
          variables: {
            skip: 0,
            limit: 25,
            query: { search: name },
            searchCategory: 'name',
          },
          fetchPolicy: 'network-only',
        });
        if (members?.data?.searchMembers?.data?.length > 0) {
          const bestCandidate = members?.data?.searchMembers?.data[0];
          if (!!bestCandidate.id) {
            if (activeCallPatientIdRef.current && bestCandidate.id !== activeCallPatientIdRef.current) {
              return;
            }
            setCallCenterPatientId(bestCandidate.id);
            refetchPharmacy();
          }
        }
      }
      // fetchMemberByName(patientParticipant.name);
      // There is a patient in conference
      if (!!patientParticipant.number) {
        const phoneRecords = await apolloClient.query({
          query: GET_PHONES_WITH_ASSOCIATIONS,
          variables: { query: { number: patientParticipant.number } },
          fetchPolicy: 'network-only',
        });
        if (_get(phoneRecords, 'data.phones.data').length > 0) {
          const formattedPhones = getFormattedPhoneAssociations(
            _get(phoneRecords, 'data.phones.data'),
            activeCallPatientIdRef.current,
          );
          const { patients } = formattedPhones;
          const patientName = getPatientName(patientParticipant);
          const patient_id = !!patientName
            ? patients
              ?.sort((a, b) => !!b.assigned_pharmacy_id - !!a.assigned_pharmacy_id)
              ?.find(p => p.name === patientName)?.id ?? formattedPhones.bestCandidate?.patient_id
            : formattedPhones.bestCandidate?.patient_id;
          if (!!patient_id) {
            if (activeCallPatientIdRef.current && patient_id !== activeCallPatientIdRef.current) {
              return;
            }
            setCallCenterPatientId(patient_id);
            refetchPharmacy();
          } else if (!!patientName) {
            fetchMemberByName(patientName);
          }
        }
      } else if (!!patientParticipant.name) {
        fetchMemberByName(patientParticipant.name);
      }
    }
  }

  function onOutcomeCompleted() {
    setOutcomeModalVisible(false);
    resetStatesAfterPostCall();
    setIsPostCall(false); // CPTC-933: Fixes call save/outcome modal back to back issue
  }

  function removeSupervisor() {
    if (twilioConnection) {
      twilioConnection.disconnect();
    }
    resetCallCenterState();
    setSupervisingCallContext(null);
    updateCallCenterStatusMutationContext('available');
  }

  function resetStatusAndCloseModal() {
    setIsSaveNumberModalOpen(false);
    resetStatesAfterSavingCallOrNumber();
  }

  async function onCallDialpadHandler(dialpadNumber) {
    const phoneRecords = await apolloClient.query({
      query: GET_PHONES_WITH_ASSOCIATIONS,
      variables: { query: { number: `+1${dialpadNumber}` } },
      fetchPolicy: 'network-only',
    });
    if (callCenterUserStatusContext !== 'oncall') {
      updateCallCenterStatusMutationContext('calldialing');
    }

    let callRecord;
    let name = 'Unknown Caller';
    // Found a phone record. Let's find the phone id and use that to make a call record.
    if (_get(phoneRecords, 'data.phones.data').length > 0) {
      const formattedPhones = getFormattedPhoneAssociations(_get(phoneRecords, 'data.phones.data'));
      const { bestCandidate } = formattedPhones;
      name = bestCandidate?.phone_label.includes('CPCC')
        ? bestCandidate?.phone_label
        : bestCandidate.name;
      callRecord = await createCallRecordMutation({
        variables: { toPhoneId: _get(bestCandidate, 'phone_id'), direction: 'outbound' },
      });
    }
    // No phone record associated to number. Will create a phone record and a call record by passing a dialpadNumber.
    else {
      callRecord = await createCallRecordMutation({
        variables: { dialpadNumber },
        direction: 'outbound',
      });
    }

    const callId = _get(callRecord, 'data.createCallRecord.data.callId');
    const toPhoneId = _get(callRecord, 'data.createCallRecord.data.toPhoneId');
    const fromCallerId = _get(callRecord, 'data.createCallRecord.data.callerIdNumber');

    currentCallIdRef.current = callId;
    makeOutboundCall({
      userId,
      toPhoneId,
      number: `+1${dialpadNumber}`,
      name,
      callId,
      fromCallerId,
      activeCallPatientIdRef,
      setShowConnectingTwilio,
      setTwilioConnection,
      setOnCallDialingParticipant,
      updateCallCenterStatusMutationContext,
      setIsOnCall,
      apolloClient,
      setUpdatedPharmacyContext,
      setIsOutboundPatient,
      setCallCenterPatientId,
    });
  }

  const onMembersPage = _get(location, 'pathname').match('members');

  function renderPhoneArea() {
    const patientInfo =
      _get(selectedPatInfoData, 'patients.data[0]') &&
      buildPatientInfo(_get(selectedPatInfoData, 'patients.data[0]'));
    if ((selectedPatInfoLoading || showConnectingTwilio) && onMembersPage) {
      return <LoadingOutlined style={{ fontSize: '25px', marginLeft: '25px' }} />;
    }

    return (
      <>
        <div className={css(sx.callCenterBar)}>
          {onMembersPage && patientInfo && (
            <CallPatientButton
              callBtnHandler={async index => {
                setShowConnectingTwilio(true);
                activeCallPatientIdRef.current = patientInfo.id;
                setCallCenterPatientId(patientInfo.id);

                const r = await createCallRecordMutation({
                  variables: { toPhoneId: patientInfo?.phoneIds[index], direction: 'outbound' },
                });
                const callId = _get(r, 'data.createCallRecord.data.callId');
                const fromCallerId = _get(r, 'data.createCallRecord.data.callerIdNumber');

                currentCallIdRef.current = callId;
                makeOutboundCall({
                  userId,
                  toPhoneId: patientInfo.phoneIds[index],
                  number: patientInfo.phones[index],
                  name: _get(patientInfo, 'patientName'),
                  callId,
                  fromCallerId,
                  patientId: patientInfo.id,
                  activeCallPatientIdRef,
                  setShowConnectingTwilio,
                  setTwilioConnection,
                  setOnCallDialingParticipant,
                  updateCallCenterStatusMutationContext,
                  setIsOnCall,
                  apolloClient,
                  setUpdatedPharmacyContext,
                  setIsOutboundPatient,
                  setCallCenterPatientId
                });
              }}
              // TODO: Don't spread
              {...patientInfo}
            />
          )}
          <div className={css(sx.dialCont)}>
            <DialPad onCallHandler={onCallDialpadHandler} />
          </div>
        </div>
      </>
    );
  }

  function renderMakeActive() {
    return (
      <MakeActive
        loadingTwilioToken={loadingTwilioToken}
        getTwilioTokenHandler={async () => {
          deregisterTwilioRefContext.current = true;
          setLoadingTwilioToken(true);
          const token = await getTwilioTokenQuery(apolloClient);

          // Adding a delay of 300ms  so user would see the loading state at least 300ms.
          // User might see the loading state flicker if the api response is too fast.
          const debouncedFn = _debounce(() => {
            setLoadingTwilioToken(false);
          }, 300);

          updateCallCenterStatusMutationContext('available');
          setIsCallCenterActivatedContext(true);
          registerTwilioDevice(
            token,
            setTwilioConnection,
            setCallDetails,
            setInboundCall,
            deregisterTwilioRefContext,
            resetCallCenterState,
            updateCallCenterStatusMutationContext,
            currentCallIdRef,
            apolloClient,
            setIsCallCenterActivatedContext,
            twilioTokenExpiredRef,
            setOnCallDialingParticipant,
            setIsOnCall,
            setShowConnectingTwilio,
            setIsOutboundPatient,
            setUpdatedPharmacyContext,
            userId,
            deviceRef,
          );
          debouncedFn();
        }}
      />
    );
  }

  function renderInbound() {
    return (
      <div className={css(sx.inboundCall)}>
        <div>
          <InboundCall
            label={inboundCall.label} // posdsible values = ['Patient', 'Plan', 'Prescriber', 'Pharmacy', 'Unknown']
            patientId={inboundCall.patient_id}
            name={inboundCall.name}
            phone={inboundCall.phone}
            insurance={inboundCall.insurance}
            acceptHandler={async () => {
              twilioConnection.accept();

              // Redirect to member's page if user is not on member's page already.
              if (!onMembersPage && inboundCall.patient_id) {
                navigate('/members');
              }

              if (_get(inboundCall, 'patient_id')) {
                activeCallPatientIdRef.current = _get(inboundCall, 'patient_id');
                setSelectedPatientId(_get(inboundCall, 'patient_id'));
                setIsInboundPatient(true);
              }

              setInboundCall(null);
            }}
            rejectHandler={() => {
              twilioConnection.reject();
              endConference();
            }}
          />
        </div>
      </div>
    );
  }

  function renderCallCenterBar() {
    if (!isCallCenterActivatedContext && callCenterUserStatusContext === 'oncall') {
      return <OnCallElsewhere />;
    }
    if (!_isEmpty(supervisingCallContext) && isCallCenterActivatedContext) {
      return (
        <OnCallSupervising
          callId={supervisingCallContext.currentCallId}
          onHangup={removeSupervisor}
          twilioDeviceRef={deviceRef.current}
        />
      );
    } else if (isOnCall && !supervisingCallContext) {
      let shouldRender = true;
      const isUnknownCaller = twilioConnection?.customParameters?.get('name')?.includes('Unknown Caller') ?? false;
      const isIncomingUnknownCall = twilioConnection?._direction === 'INCOMING' && callDetails.name === 'Unknown Caller';
      if (isUnknownCaller || isIncomingUnknownCall) {
        if (isUnknownNumberSaved && !!patientIdForUnknownNumber) {
          shouldRender = patientIdForUnknownNumber === selectedPatInfoData?.patients?.data[0]?.id;
        } else {
          shouldRender = selectedPatientId === selectedPatInfoData?.patients?.data[0]?.id;
        }
      }

      if (shouldRender) {
        const patientInfo =
          _get(selectedPatInfoData, 'patients.data[0]') &&
          buildPatientInfo(_get(selectedPatInfoData, 'patients.data[0]'));
        return (
          <OnCallContainer
            callId={currentCallIdRef.current}
            isCallIdSet={isCallIdSet}
            endConference={endConference}
            refreshActiveConfRef={refreshActiveConfRef}
            refreshActiveConf={refreshActiveConfRef.current}
            onCallDialingParticipant={onCallDialingParticipant}
            onCallUpdatingParticipants={onCallUpdatingParticipants}
            setOnCallDialingParticipant={setOnCallDialingParticipant}
            onSwitchPatient={patient_id => {
              activeCallPatientIdRef.current = patient_id;
              setCallCenterPatientId(patient_id);
            }}
            onClickUnknownNumber={onClickUnknownNumber}
            twilioConnection={twilioConnection}
            selectedPatientData={patientInfo}
            isSaveCallEnabled={saveCallEnabled}
            isSaveCallOnly={saveCallOnly}
            isPostCall={isPostCall}
            twilioDeviceRef={deviceRef.current}
          />
        );
      }
    } else if (inboundCall) {
      return renderInbound();
    } else if (isCallCenterActivatedContext) {
      return renderPhoneArea();
    }
    return renderMakeActive();
  }

  return (
    <div>
      <div className={css(sx.callCenterContainer, inboundCall ? sx.green : null)}>
        {renderCallCenterBar()}
        <CallCenterStatus
          twilioDeviceRef={deviceRef.current}
        />
      </div>

      <SaveNumberModal
        callId={unknownNumberCallIdRef.current}
        saveCallOnly={saveCallOnly}
        patient={
          _get(selectedPatInfoData, 'patients.data[0]') &&
          buildPatientInfo(_get(selectedPatInfoData, 'patients.data[0]'))
        }
        patientId={!!patientIdForUnknownNumber ? patientIdForUnknownNumber : callCenterPatientId}
        number={unknownNumberRef.current}
        onCancel={() => resetStatusAndCloseModal()}
        afterClose={() => {
          setSaveCallOnly(false);
          unknownNumberCallIdRef.current = null;
          unknownNumberRef.current = null;

          setIsSaveNumberModalOpen(false);
        }}
        isModalOpen={isSaveNumberModalOpen}
        onSuccessSaveNumber={onSuccessSaveNumber}
        setSaveCallOnly={setSaveCallOnly}
        isPostCall={isPostCall}
        setSaveCallEnabled={setSaveCallEnabled}
        setIsPostCall={setIsPostCall}
      />
      <CallOutcomeModal
        callId={lastCallId || currentCallIdRef.current}
        isModalOpen={showOutcomeModal}
        onSuccessCallOutcome={onOutcomeCompleted}
        patient={
          _get(selectedPatInfoData, 'patients.data[0]') &&
          buildPatientInfo(_get(selectedPatInfoData, 'patients.data[0]'))
        }
        patientId={!!patientIdForUnknownNumber ? patientIdForUnknownNumber : callCenterPatientId}
      />
    </div>
  );
};

export default CallCenterBar;